'use client';

import { useAutomaticMouseMovementOutcome } from '../useAutomaticMouseMovementOutcome/useAutomaticMouseMovementOutcome';

export const MouseMovementSender = () => {
  useAutomaticMouseMovementOutcome();
  return null;
};
